import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "24",
      height: "24",
      fill: "currentColor",
      "fill-opacity": ".15",
      rx: "12"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 7.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M8.5 14a1 1 0 1 0 0 2 1 1 0 0 0 0-2m7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "m16.5 8.5-9 7"
    }, null, -1)
  ]))]))
}
export default { render: render }